import { createResourceExplorerGcpBillingExportDataErrorSelector } from "./createResourceExplorerGcpBillingExportDataErrorSelector";

import { RootState } from "../../../../store";

export const resourceExplorerGcpBillingExportDataErrorSelector = (
  state: RootState,
) => {
  return createResourceExplorerGcpBillingExportDataErrorSelector(state);
};
